import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { Button } from './Button'

export function Header() {
  const { user, isAdmin, logout } = useAuth()
  const { t } = useTranslation()
  const location = useLocation()

  return (
    <header className="bg-bg">
      <div className="max-w-7xl mx-auto px-lg">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center" viewTransition>
            <img src="/logo-192x192.avif" alt="Logo" className="w-6 h-6" />
            <span className="text-xl lexend-deca-regular text-text">{t('common.appName')}</span>
          </Link>

          <nav className="flex items-center gap-md">
            {(import.meta.env.DEV || isAdmin) && (
              <Link
                to="/unified-debug-notifications"
                className="text-orange-600 hover:text-orange-700 transition-colors text-sm font-medium"
                viewTransition
              >
                  🔔 Debug Notifications
              </Link>
            )}
            {user ? (
              <>
                <Link
                  to="/profile"
                  className="text-text-muted hover:text-text transition-colors"
                  viewTransition
                >
                  {t('auth.profile')}
                </Link>
                <Button variant="tertiary" size="sm" onClick={logout}>
                  {t('auth.logout')}
                </Button>
              </>
            ) : (
              <>
                <Link to="/login" viewTransition>
                  <Button 
                    variant={location.pathname === '/login' ? 'primary' : 'tertiary'} 
                    size="sm"
                  >
                    {t('auth.signIn')}
                  </Button>
                </Link>
                <Link to="/register" viewTransition>
                  <Button 
                    variant={location.pathname === '/register' ? 'primary' : 'secondary'} 
                    size="sm"
                  >
                    {t('auth.signUp')}
                  </Button>
                </Link>
              </>
            )}
          </nav>
        </div>
      </div>
    </header>
  )
}